import { PATHS } from '@ctcells/core'

/**
 * 웹훅 상세 판 주소(`/admin/webhooks/:recipientId` · eric 2026-10-29 「웹훅 리스트를 보여주고.. 해당 웹훅을 클릭하면 상세페이지」).
 * 사용자 탭(`/admin/members/:userId`)과 같은 꼴 — 목록 행 · 라우트 표 · 닫기가 이 한 출처를 쓴다.
 */
export const WEBHOOK_DETAIL_ROUTE = `${PATHS.adminWebhooks}/:recipientId`

export function webhookDetailPath(recipientId: string): string {
  return `${PATHS.adminWebhooks}/${encodeURIComponent(recipientId)}`
}
